import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.twinDuplicatePrompt,
      callback: function ($$v) {
        _vm.twinDuplicatePrompt = $$v;
      },
      expression: "twinDuplicatePrompt"
    }
  }, [_vm.twinDuplicatePrompt ? _c('core-dtwin-duplicate-base', {
    attrs: {
      "orgTwin": _vm.twinObject,
      "orgTwinStates": _vm.twinDataStates
    },
    on: {
      "forceRefreshStates": _vm.forceRefreshStates,
      "close": _vm.duplicateCloseEvent
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.twinSyncPrompt,
      callback: function ($$v) {
        _vm.twinSyncPrompt = $$v;
      },
      expression: "twinSyncPrompt"
    }
  }, [_vm.twinSyncPrompt ? _c('core-dtwin-sync', {
    attrs: {
      "orgTwin": _vm.twinObject,
      "orgTwinStates": _vm.twinDataStates
    },
    on: {
      "close": _vm.syncCloseEvent
    }
  }) : _vm._e()], 1), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteConfirmation'),
      "open": _vm.twinDeletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
        color: 'red',
        emit: 'delete',
        disabled: _vm.twinDependencies === null || !_vm.canDeleteTwin
      }],
      "color": "red"
    },
    on: {
      "cancel": function ($event) {
        _vm.twinDeletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.deleteTwin(_vm.twinObject);
      }
    }
  }, [_vm.twinDependencies && _vm.twinDependencies.aggregatedStates && _vm.twinDependencies.aggregatedStates.length ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteCannotDeleteText')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.twinDependencies.aggregatedStates,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [item.isTwin ? [_c('a', {
          attrs: {
            "href": `/#/${item.twinType === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt'}/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1373246036)
  })] : [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteConfirmText')) + "\n    ")]], 2), _c('core-csv-export-dialog-multi', {
    attrs: {
      "isOpen": _vm.showExportDialog,
      "type": "digitalTwin"
    },
    on: {
      "close": function ($event) {
        _vm.showExportDialog = false;
      }
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.digitalTwins.head'),
      "subtitle": _vm.$i18n_t('Common.digitalTwins.headInfo')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "data-cy": "dt_csv_export",
            "color": _vm.color,
            "prepend-icon": "fa-file-csv"
          },
          on: {
            "click": function ($event) {
              _vm.showExportDialog = true;
            }
          }
        }), _c(VBtn, {
          class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.home.favorites'),
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.favouriteFilter = !_vm.favouriteFilter;
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(_vm._s(_vm.favouriteFilter ? 'fas' : 'fal') + " fa-star")])], 1), _c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        }), _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push('/digitaltwin-mgmt');
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-sitemap")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.treeView')) + "\n      ")], 1)];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c('custom-multi-search', {
    attrs: {
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "defaultSearchType": {
        param: 'title',
        text: 'Title'
      },
      "dense": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  }), _vm.accountFilterReady ? _c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.localizedTableOptions.headers,
      "footer-props": _vm.localizedTableOptions.footerProps,
      "item-key": "id",
      "hide-default-header": ""
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination]
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (headerProps) {
        return [_c('thead', {
          staticClass: "v-data-table-header"
        }, [_c('tr', _vm._l(headerProps.props.headers, function (header) {
          return _c('th', {
            key: `asset_table_header_${header.value}`,
            class: _vm.detailTableHeaderColClass(header, headerProps.props)
          }, [header.value === 'id' ? [_vm._v(" ")] : header.value === 'statesCount' ? [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.list.states')) + "\n                    "), _c('br'), _vm._v("\n                    / " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.list.rules')) + "\n                  ")] : header.value === 'title' ? [_c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.title,
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v("\n                      " + _vm._s(header.text) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.title}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    / (\n                    "), _c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.id,
            on: {
              "click": function ($event) {
                return headerProps.on.sort('id');
              }
            }
          }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Common.id')) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.id}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    )\n                  ")] : [_c('span', {
            on: {
              "click": function ($event) {
                header.sortable ? headerProps.on.sort(header.value) : null;
              }
            }
          }, [_vm._v(_vm._s(header.text))]), header.sortable ? _c(VIcon, {
            staticClass: "v-data-table-header__icon",
            attrs: {
              "size": "18"
            }
          }, [_vm._v("fas fa-sort-up")]) : _vm._e()]], 2);
        }), 0)])];
      }
    }, {
      key: "item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "65px"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "16"
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.data.faIcon))])], 1), _c('td', {
          staticClass: "clickable",
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "260px"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_c('span', {
          staticClass: "mx-2"
        }, [_c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.id}`
          }
        }, [_vm._v("\n                    " + _vm._s(props.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.id) + ")\n                  ")])], 1)]), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "200px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.hierarchyLevel > 1 ? props.item.hierarchyLevel : _vm.$i18n_t('DigitalTwin.DigitalTwin.list.rootItem')) + "\n                "), props.item.parent ? [_vm._v("\n                   \n                  "), _c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.parent.id}`
          }
        }, [_c(VIcon, {
          attrs: {
            "size": "11"
          }
        }, [_vm._v("fal fa-folder-tree")]), _vm._v("\n                      " + _vm._s(props.item.parent.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.parent.id) + ")\n                  ")], 1)] : _vm._e()], 2), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "170px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.tenant.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.tenant.id) + ")\n              ")]), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "120px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.statesCount) + " / " + _vm._s(props.item.rulesCount) + "\n              ")]), _c('td', {
          staticClass: "text-right",
          staticStyle: {
            "min-width": "160px"
          }
        }, [_vm.twinCanBeEdited(props.item) && props.item.parentId > 1 ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.duplicateDigitalTwin'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.twinObject = props.item;
              _vm.twinDuplicatePrompt = true;
            }
          }
        }, [_vm._v("\n                    fal fa-copy\n                  ")]), _vm._v("\n                   \n                ")] : _vm._e(), _vm.twinCanBeEdited(props.item) ? [_vm.twinCanBeEdited(props.item) ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.syncDigitalTwin'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.twinObject = props.item;
              _vm.twinSyncPrompt = true;
            }
          }
        }, [_vm._v("\n                    fal fa-share-square\n                  ")]) : _vm._e(), _vm._v("\n                   \n                ")] : _vm._e(), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/digitaltwin-mgmt/map/twin/${props.item.id}`);
            }
          }
        }, [_vm._v("\n                  fal fa-map-marked\n                ")]), _vm._v("\n                 \n                "), _vm.hasTwinManageAllPermission && props.item.parentId && (!props.item.children || props.item.children.length === 0) ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.twinObject = props.item;
              _vm.twinDeletePrompt = true;
              _vm.fetchTwinDependencies(_vm.twinObject);
            }
          }
        }, [_vm._v("\n                    fal fa-trash-alt\n                  ")]), _vm._v("\n                   \n                ")] : _vm._e(), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.viewDetails'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/digitaltwin-mgmt/${props.item.id}`);
            }
          }
        }, [_vm._v("\n                  fal " + _vm._s(_vm.twinCanBeEdited(props.item) ? 'fa-edit' : 'fa-eye') + "\n                ")])], 2)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n              ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }], null, false, 2436960577)
  }) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };